// src/components/NotFound.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';
import '../styles/NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1>404</h1>
        <h2>Página no encontrada</h2>
        <p>Lo sentimos, la página que estás buscando no existe.</p>
        <button onClick={() => navigate('/')} className="home-btn">
          <FaHome /> Volver al inicio
        </button>
      </div>
    </div>
  );
};

export default NotFound;